<div *ngIf="!isAuthenticated; else dashboard">
  <div class="background-container">
    <!-- Login Card with Animation -->
    <div class="overlay-card">
      <h1>Welcome to BUILDSPACE Connector</h1>
      <p>Your gateway to secure, efficient and soveirgn data exchange.</p>
  
      <div class="button-container">
        <button mat-raised-button color="primary" (click)="login()">Login</button>
        <a href="mailto:isotiropoulos@singularlogic.eu" mat-flat-button target="_blank">
          Contact Us 
        </a>
      </div>
    </div>
  </div>
  
</div>

<ng-template #dashboard>
  <router-outlet></router-outlet>

  <div style="display: none">
    <mat-card><mat-card-header></mat-card-header></mat-card>
  </div>
</ng-template>
